// Responsive breakpoint constant
// Mobile/tablet: < 1024px
// Desktop: >= 1024px
export const MOBILE_BREAKPOINT = 1024;

// Utility function to check if current viewport is desktop width
// Uses matchMedia to stay consistent with CSS media queries (accounts for scrollbar, viewport meta, etc.)
export const isDesktopWidth = () => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(`(min-width: ${MOBILE_BREAKPOINT}px)`).matches;
};
